import React from 'react';
import BalanceInvestissement from '../../components/simulation/Panels/BalanceInvestissement';
import Panel from './Panel';

class BalanceInvestissementPanel extends Panel {
	constructor() {
		super();
		this.code = 'BLC_INV';
		this.icon = {
			iconSet: 'Lucide',
			name: 'Building2',
		};
		this.isMandatory = true;
		this.libelle = "Balance d'investissement";
		this.size = 4;
	}

	getComponent = function getComponent(data: any): React.ReactElement {
		return <BalanceInvestissement data={data} />;
	};
}

export default BalanceInvestissementPanel;
